'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import './error.css';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (error) {
      datadogRum.addError(error, {
        message: 'Fatal error triggered root client error boundary',
      });
    }
  }, [error]);
  return (
    <div id="nw-50x">
      <div id="nw-heading-wrap">
        <h1>Sorry, looks like something slipped up.</h1>
      </div>
      <div className="nw-button-wrap">
        <a className="nw-button" onClick={reset}>
          Let&apos;s try that again!
        </a>
      </div>
    </div>
  );
}
